import { t as tinycolor } from '../../../../tinycolor-c9a47691.js';
import { COLOR_CHANNELS } from '../../../../configs/index.js';
import '../../../../typeof-92b42de1.js';

var min = Math.min,
    max = Math.max;

var applyBrightness = function applyBrightness(color, brightness) {
  var rgba = tinycolor(color).toRgb();
  COLOR_CHANNELS.forEach(function (channel) {
    rgba[channel] += brightness;
    rgba[channel] = min(max(0, rgba[channel]), 255);
  });
  return tinycolor(rgba).toHex8String();
};

export { applyBrightness as default };
